<!--
 * @Author: your name
 * @Date: 2021-08-25 17:49:23
 * @LastEditTime: 2021-11-08 18:52:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \booksnote\src\views\user\User.vue
-->
<template>
  <div class="user">
    <div class="user-main">
      <div class="user-left">
        <el-button
          type="primary"
          @click="to('index')"
        >返回首页</el-button>
        <el-button :type="$route.name === 'accountSetting' ? 'info' : 'primary'" @click="to('accountSetting')">账号管理</el-button>
        <el-button v-if="isShow" :type="$route.name === 'accountSetting' ? 'primary' : 'info'" @click="to('loginRecord')">登录信息</el-button>
      </div>

      <div class="user-center">
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      loginShow: false
    }
  },
  computed: {
    isShow() {
      let uInfo = window.localStorage.getItem('userInfo')
      uInfo = uInfo ? JSON.parse(uInfo).groupid : ''
      return uInfo && uInfo === 99
    }
  },
  methods: {
    to(path) {
      if (this.$route.name === path) return
      this.$router.push({ name: path })
    }
  }
}
</script>

<style lang="less">
.user {
  height: 100%;
  padding: 10px;
  .user-main {
    height: 100%;
    display: flex;
    justify-content: space-between;
    border: 1px solid #ccc;

    .user-left {
      height: 100%;
      padding: 10px;
      border-right: 1px solid #ccc;
      display: flex;
      flex-direction: column;
      .el-button {
        margin-left: 0;
        margin-top: 10px;
      }
      button a {
        text-decoration: none;
        color: #fff;
      }
    }
    .user-center {
      flex: 1;
      padding: 10px;
      max-width: 100%;
      overflow-x: hidden;
      header {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #ccc;
      }
      section {
        max-width: 100%;
      }
    }
  }
}
</style>
